import React, { Fragment } from 'react';

function getDesign(messageListOtpLogin) {

  return (
    <Fragment>
      <div className="contentInner">
        <div className="ds-heading ds-heading--sm">
          <h2 className="ds-heading__title">{messageListOtpLogin.M011_notices}</h2>
        </div>
        <ul className="ds-listText ds-listText--md">
          <li className="ds-listText__item">{messageListOtpLogin.M012_notice001}</li>
          <li className="ds-listText__item">{messageListOtpLogin.M012_notice002}</li>
          <li className="ds-listText__item">{messageListOtpLogin.M012_notice003}</li>
        </ul>
      </div>
    </Fragment>
  );
}

export { getDesign }
